export { DecodeHtmlEntitiesModule } from './decode.module';
export { DecodeHtmlEntities } from './decode-html-entities.Pipe';
//# sourceMappingURL=index.js.map